import { types } from 'mobx-state-tree';
import { Location } from './Location';

export const Seller = types.model('seller', {
  id: types.maybe(types.number),
  name: types.maybe(types.string),
  rank: types.maybe(types.number),
  price: types.maybe(types.number),
  currency: types.maybe(types.number),
  location: types.optional(types.map(Location), {}),
  condition: types.maybe(types.number),
  policy: types.maybe(types.string),
});
